import BaseAccordion from 'components/Accordions/BaseAccordion';
import ConfirmationModal from 'components/Modals/ConfirmationModal';
import { getRelatedGlobalActionsFromGroup } from 'features/GlobalActions/features/ActionList/utils/actionListUtils';
import { useGetConnectedDevicesQuery } from 'services/devices/devices.api';
import { useGetGlobalActionsQuery } from 'services/globalActions/globalActions.api';
import { resolveGroupDeviceIds } from '../../utils/settings.utils';

// Confirmation modal for deleting a device group, showing devices in the group.
const DeleteGroupModal = ({ toDelete, resolveDelete }) => {
  const { data: connectedDevices = [] } = useGetConnectedDevicesQuery();
  let groupDevices = [];
  if (toDelete && Array.isArray(toDelete.devices)) {
    const idSet = new Set(resolveGroupDeviceIds(toDelete));
    groupDevices = connectedDevices.filter((device) => idSet.has(device.id));
  }

  const { data: globalActionList = [] } = useGetGlobalActionsQuery(undefined, { skip: !toDelete });

  return (
    <ConfirmationModal
      show={toDelete}
      handleShow={() => resolveDelete(false)}
      bodyTxt={(() => {
        let relatedGlobalActions = [];
        if (toDelete) {
          relatedGlobalActions = getRelatedGlobalActionsFromGroup(toDelete, globalActionList);
        }
        return (
          <div>
            <p>
              Are you sure you want to delete <strong>{toDelete?.name}</strong> from the workplace?
            </p>
            {relatedGlobalActions.length > 0 && (
              <div>
                <p>
                  <br />
                  This will affect the following Global Actions:
                </p>

                <BaseAccordion
                  header={<span>Related Global Actions ({relatedGlobalActions.length})</span>}
                  rounded
                  bodyBackground="#436C9A"
                  style={{ borderRadius: '12px', overflow: 'hidden' }}
                >
                  <div
                    className="customScrollbar-Y m-0 ps-3 overflow-y-auto"
                    style={{ maxHeight: 200 }}
                  >
                    {relatedGlobalActions.map((action, index) => (
                      <div className="border-bottom border-1 w-100" key={action + index}>
                        {action}
                      </div>
                    ))}
                  </div>
                </BaseAccordion>
              </div>
            )}
          </div>
        );
      })()}
      cancelBtnTxt="Cancel"
      confirmBtnTxt="Yes"
      confirmButtonStyle={{
        backgroundColor: 'red',
        color: 'white',
      }}
      cancelHandler={() => resolveDelete(false)}
      confirmHandler={() => resolveDelete(true)}
    />
  );
};

export default DeleteGroupModal;
